import { useEffect } from 'react';
import { useHistory } from 'react-router';

import { ContainerLayout } from '../../../../../common/hub/ContainerLayout';
import EnrolmentLayout from '../../../../../common/hub/EnrolmentLayout';
import { OptionCard, OptionCardContent } from '../../../../../components/EnrolmentManagement/OptionCard';
import { IntentIntro } from '../../../../../components/IntentIntro';
import { useSelectEnrolmentModal } from '../../../../../components/Modals/SelectEnrolmentModal/SelectEnrolmentModal';
import { PATH_HUB_CR_REPORT_ISSUE } from '../../../../../util/pagePath';
import { usePageHeader } from '../../../../../v2/app-shell/usePageHeader';
import { getReportIssueMenuOptions } from './helpers';

function ManageServiceReportAnIssue() {
  const history = useHistory();
  const enrolmentToken = new URLSearchParams(history.location.search).get('token');
  const { SelectEnrolmentModal } = useSelectEnrolmentModal();
  const choices = getReportIssueMenuOptions();
  const { setHeader } = usePageHeader();

  useEffect(() => {
    setHeader({
      label: 'Report an issue',
      showIcon: false,
      showBackButton: true,
    });
  }, [setHeader]);

  return (
    <EnrolmentLayout
      sectionHeading="Home"
      mainHeading="Report an issue"
      showEnrolmentStatus={false}
      showSummerModeEnrolmentStatus={false}
    >
      <SelectEnrolmentModal
        enrolmentLinkTo={(enrolment) => `${PATH_HUB_CR_REPORT_ISSUE}?token=${enrolment.enrolmentId}`}
        open={!enrolmentToken}
      />
      <ContainerLayout>
        <IntentIntro>Report any issues to help us improve our service.</IntentIntro>
        <ul className="list-none">
          {choices.map(({ text, to, element, headerLabel }) => {
            const linkTo = headerLabel
              ? { pathname: to, search: `?token=${enrolmentToken}`, state: { headerLabel } }
              : `${to}?token=${enrolmentToken}`;
            return (
              <li key={text}>
                <OptionCard linkTo={linkTo} type={element}>
                  <OptionCardContent>{text}</OptionCardContent>
                </OptionCard>
              </li>
            );
          })}
        </ul>
      </ContainerLayout>
    </EnrolmentLayout>
  );
}

export default ManageServiceReportAnIssue;
